export default __webpack_public_path__ + "static/media/white-logo.1b67c36f.png";